'use strict';

var processInclude = require('./util');
const { showToastMessage } = require('./../js/components/toast');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./components/passwordToggle'));
    processInclude(require('./thirdParty/bootstrapCollapseCustomization'));

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('success') === 'true') {
        let message = document.querySelector('.js-login').getAttribute('data-success-message');
        showToastMessage({
            message: message,
            alertType: 'alert-success'
        });
    }
});
